import React, { Component } from 'react'
import { isEqual } from 'lodash'
import accepts from 'attr-accept'
import async from 'async'

// import styles
import './dropzone.scss'

class Dropzone extends Component {

  constructor (props) {
    super(props)
    this.state = {
      isDragActive: false,
      isDragReject: false
    }
    this.onClick = this.onClick.bind(this)
    this.onDragLeave = this.onDragLeave.bind(this)
    this.onDragEnter = this.onDragEnter.bind(this)
    this.onDragOver = this.onDragOver.bind(this)
    this.onDrop = this.onDrop.bind(this)
    this.fileAccepted = this.fileAccepted.bind(this)
  }

  shouldComponentUpdate (nextProps, nextState) {
    return !isEqual(this.props, nextProps) || !isEqual(this.state, nextState)
  }

  onClick () {
    this.refs.fileInput.click()
  }

  onDragLeave () {
    this.setState({
      isDragActive: false,
      isDragReject: false
    })
  }

  onDragOver (e) {
    e.preventDefault()
    try {
      e.dataTransfer.dropEffect = 'copy'
    } catch (err) {
    }
    return false
  }

  onDragEnter (e) {
    e.preventDefault()

    const dataTransferItems = e.dataTransfer && e.dataTransfer.items ? e.dataTransfer.items : []
    const allFilesAccepted = this.allFilesAccepted(Array.prototype.slice.call(dataTransferItems))

    this.setState({
      isDragActive: allFilesAccepted,
      isDragReject: !allFilesAccepted
    })
  }

  rotateBase64 (base64Image) {
    return new Promise(function (resolve, reject) {
      // create an off-screen canvas
      let offScreenCanvas = document.createElement('canvas')
      let offScreenCanvasCtx = offScreenCanvas.getContext('2d')

      // create Image
      let img = new window.Image()
      img.src = base64Image

      // on image load
      img.onload = () => {
        // set its dimension to rotated size
        offScreenCanvas.height = img.width
        offScreenCanvas.width = img.height

        // rotate and draw source image into the off-screen canvas:
        offScreenCanvasCtx.rotate(Math.PI / 2)
        offScreenCanvasCtx.translate(0, -offScreenCanvas.width)
        offScreenCanvasCtx.drawImage(img, 0, 0)

        // encode image to data-uri with base64
        resolve(offScreenCanvas.toDataURL('image/jpeg'))
      }

      // on image error
      img.onerror = (err) => {
        reject(err)
      }
    })
  }

  onDrop (e) {
    e.preventDefault()

    this.setState({
      isDragActive: false,
      isDragReject: false
    })

    if (this.props.onDrop) {
      this.props.onDrop()
    }

    const droppedFiles = e.dataTransfer ? e.dataTransfer.files : e.target.files
    let acceptedFiles = []
    let rejectedFiles = []

    async.each(droppedFiles, (file, cb) => {
      if (this.fileAccepted(file)) {
        // if (this.props.accept === 'image/*') {
        // Check if image
        if (file.type.indexOf('image/') !== -1 && this.props.includeCircles) {
          let reader = new window.FileReader()
          reader.onloadend = (e) => {
            let newFile = {}
            newFile.file = file
            newFile.circles = []
            newFile.imageUrl = e.target.result
            newFile.rotation = 0
            acceptedFiles.push(newFile)
            cb()
          }
          reader.readAsDataURL(file)
        } else {
          acceptedFiles.push(file)
          cb()
        }
      } else {
        rejectedFiles.push(file)
        cb()
      }
    }, () => {
      if (acceptedFiles.length > 0) {
        if (this.props.onDropAccepted) {
          this.props.onDropAccepted(acceptedFiles)
        }
      }
      if (rejectedFiles.length > 0) {
        if (this.props.onDropRejected) {
          this.props.onDropRejected(rejectedFiles)
        }
      }
      document.getElementById('dropzone_input').value = ''
    })
  }

  fileAccepted (file) {
    if (this.props.accept === '*') {
      return true
    }
    return accepts(file, this.props.accept)
  }

  allFilesAccepted (files) {
    return files.every(this.fileAccepted)
  }

  render () {
    let className = ''
    const { isDragActive, isDragReject } = this.state

    if (isDragActive) {
      className += 'active'
    }

    if (isDragReject) {
      className += ' rejected'
    }
    return (
      <div className={'dropzone ' + className} onClick={this.onClick} onDragLeave={this.onDragLeave} onDragEnter={this.onDragEnter} onDragOver={this.onDragOver} onDrop={this.onDrop}>
        <input id='dropzone_input' style={{display: 'none'}} type='file' ref='fileInput' onChange={this.onDrop} capture={this.props.capture} multiple />
        {this.props.children}
      </div>
    )
  }

}

Dropzone.defaultProps = {
  accept: 'application/pdf,image/jpeg,image/jpeg,image/png,image/gif,image/bmp,image/x-windows-bmp,application/mspowerpoint,application/powerpoint,application/vndms-powerpoint,application/x-mspowerpoint,application/msword,application/excel,application/vndms-excel,application/x-excel,application/x-msexcel,text/plain,application/mspowerpoint,application/vndms-powerpoint,application/rtf,application/x-rtf,text/richtext,application/wordperfect,application/x-wpwin,application/vndopenxmlformats-officedocumentspreadsheetmlsheet,application/vndopenxmlformats-officedocumentpresentationmlpresentation,application/vnd.openxmlformats-officedocument.presentationml.slideshow,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/vnd.oasis.opendocument.text,application/vnd.oasis.opendocument.presentation,application/vnd.oasis.opendocument.spreadsheet,application/vnd.ms-excel,application/vnd.ms-powerpoint,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
}

export default Dropzone




// WEBPACK FOOTER //
// ./src/app/shared/components/Dropzone/index.js